(function () {
    let $window = $(window);
    let flexslider = {vars: {}};
    let flexsliderContainer = $('.flexslider');

    function debounce(func, wait, immediate) {
        let timeout;
        return function () {
            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function getGridSize() {
        return (window.innerWidth < 600) ? 3 :
            (window.innerWidth < 900) ? 6 : 10;
    }

    let setImageLinks = debounce(function() {
        console.info("setting image links");
        let windowWidth = $window.width();
        let linkSource = 'src-small';
        if (windowWidth > 1280) {
            linkSource = 'src-large';
        } else if (windowWidth > 768) {
            linkSource = 'src-medium';
        }
        $('.flexslider .slide a').each(function() {
            let $link = $(this);
            $link.attr('href', $link.data(linkSource));
        });
    }, 250);

    window.addEventListener('resize', setImageLinks);

    $(document).ready(function () {
        setImageLinks();

        flexsliderContainer.flexslider({
            animation: "slide",
            animationLoop: false,
            itemWidth: 125,
            itemMargin: 30,
            minItems: getGridSize(),
            maxItems: getGridSize(),
            slideshow: false
        });
        flexsliderContainer.magnificPopup({
            delegate: '.slide a',
            gallery: {
                enabled: true,
                navigateByImgClick: false,
                tCounter: ''
            },
            image: {
                titleSrc: 'title',
            },
            type: 'image',
            verticalFit: true,
            callbacks: {
                open: function () {
                    let that = this;
                    let magnificContainer = document.getElementsByClassName('mfp-content')[0];
                    let touchListener = ZingTouch.Region(magnificContainer);
                    let figure = document.getElementsByClassName("mfp-figure")[0];

                    touchListener.bind(figure, 'swipe', function (e) {
                        if (e.detail.data.length > 0) {
                            let direction = e.detail.data[0].currentDirection;
                            if (direction > 135 && direction < 225) {
                                that.next();
                            } else if (direction > 315 || direction < 45) {
                                that.prev();
                            }
                        }
                    });
                }
            }
        });
    });

    $window.resize(function () {
        let gridSize = getGridSize();
        flexslider.vars.minItems = gridSize;
        flexslider.vars.maxItems = gridSize;
    });
})();